import { Component, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import { MatSort } from '@angular/material/sort';
import { MatPaginator } from '@angular/material/paginator';
import { MatTableDataSource } from '@angular/material/table';
import { ScreenUtilsService } from '../../../rds-utilities/screen-utils.service';
import { DatabaseGwService } from '../../../rds-objects/services/database-gw.service';

@Component({
	selector: 'rds-output-mat-table',
	templateUrl: './output-mat-table.component.html',
	styleUrls: ['./output-mat-table.component.scss']
})
export class OutputMatTableComponent implements OnInit {
 
	defaultLabel:any = {
		emptyRecordText : "There is no a record!",
		createNew: "Create new"
	};

	defaultOption:any = {
		currency_symbol : '$'
	}
	
	defaultColDef:any = {
		fieldname: "",
		fieldlabel: "",
		colheader: "",
	};

	statusMappingColor:any = {
		"success": "rds__badge-success",
		"success_2": "rds__badge-success-2",
		"open": "rds__badge-info",
		"hold": "rds__badge-secondary",
		"warning": "rds__badge-warning",
		"warning_2": "rds__badge-warning-2",
		"error": "rds__badge-error"
	}

	@Input() dataSource: any = new MatTableDataSource();
	@Input() columnDefs: any[] = []; 

	@Input() filterRecord:any = {};
	@Input() apiPATH:string = '';
	
	@Input() totalRecord:number = 0;
	@Input() refreshDate: any = Date.now();
	@Input() option:any = {};
	@Input() rowHeight:number = 33;
	@Input() pageHeaderSpace:number = 200;//200 space header and footer,
	@Input() hasAction:boolean = true;
	@Input() labelOpt:any = {};

	@ViewChild(MatPaginator, { static: true }) paginator: MatPaginator;
	@ViewChild(MatSort, { static: true }) sort: MatSort;

	rowPerScreen:number = 30;
	colPerScreen:number = 5;
	lstRows: any[] = [];
	isLoading:boolean=true;

	tableMeta:any = {
		displayColumns: []
	};
	
	

	constructor(
		private $screen: ScreenUtilsService,
		private $db : DatabaseGwService
	) { }

	ngOnInit() {
		this.rowPerScreen = this.$screen.getTableRow(120, 30);
		Object.assign(this.defaultLabel, this.labelOpt);
		this.initLimitRecord();
		this.loadData();
	}

	loadData(){
		if(this.apiPATH){
			this.isLoading = true;
			this.totalRecord = 0;
			this.dataSource = new MatTableDataSource<any>();

			this.$db.query(this.filterRecord, this.apiPATH).subscribe(res => {
				this.refreshDate = Date.now();
				this.reRenderDatasource(res.data);
				this.totalRecord = res.meta.total;
				this.isLoading = false;
			}, resErr => {
				this.isLoading = false;
			});

		}
		
	}
	initLimitRecord(){
		let limitRecord: any = this.$screen.getTableRow(this.pageHeaderSpace, 33);//200 space header and footer, 33 row height
      	this.rowPerScreen = parseInt(limitRecord);
		this.colPerScreen = this.columnDefs.length || 0;
	}

	reRenderDatasource(lstDatas:any[]){
		this.dataSource = new MatTableDataSource<any>(lstDatas);
		this.dataSource.paginator = this.paginator;
		this.totalRecord = lstDatas.length;

		this.dataSource.filterPredicate = (data: any, filter) => {
			const dataStr = JSON.stringify(data).toLowerCase();
			return dataStr.indexOf(filter) != -1;
		}
	}

}
